import { Box } from '@mui/material';
import React from 'react'
import { MDTypography } from './MDTypography';

interface IProps{
    label : string;
    value : string;
}

export const SimpleField = (props : IProps) => {
    return (
        <Box justifyContent="space-between" flexDirection="row" display="flex">
            <MDTypography variant='span' mr={2}>{props.label}</MDTypography>
            <MDTypography variant='span' color='secondary'>{props.value}</MDTypography>
        </Box>
    )
}
